import React from 'react'
import PropTypes from 'prop-types';
import MainFormWrapper from "./dataEdit/MainFormWrapper";

function Index(
    {
        expanded
    }) {
    return expanded && <MainFormWrapper/>
}

Index.propTypes = {
    classes: PropTypes.any,
}

export default Index;